/**
 * Whole number with a "." thousands separator ("1.000", "12.345").
 *
 * Deliberately not `toLocaleString("sl-SI")`: the production server's ICU groups
 * four-digit numbers ("1.000") while browsers don't ("1000"), so text rendered on
 * the server and again on the client differs and React fails hydration (#418).
 */
export const formatCount = (value: number): string =>
  String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")
